import React, { useMemo } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { UILoader } from '@futrli/ui-components';
import { useApiView } from '@futrli/views/hooks/useApiView';
import { useSxpContext } from '@futrli/predict/core/sxp-context/sxp-context';
import { WorkspacesListView } from '@futrli/views/views/workspaces/WorkspacesListView/WorkspacesListView';

import { getWorkspaceEntryDecision } from './utils';

export const WorkspacesEntryGates: React.FC = () => {
  const flags = useFlags();
  const { pathname } = useLocation();
  const { sbcBaseUrl } = useSxpContext();

  const view = useApiView(useMemo(() => new WorkspacesListView(flags), [flags]));

  const { currentUser, isLoading, workspaces, workspacesError } = view.state;

  if (isLoading) {
    return <UILoader isFull />;
  }

  const decision = getWorkspaceEntryDecision({
    workspaces,
    workspacesError,
    currentUser,
    sbcBaseUrl,
    isDefaultWorkspaceEnabled: !!flags.defaultWorkspace,
    pathname
  });

  if (decision.type === 'error') {
    throw decision.error;
  }

  if (decision.type === 'navigate') {
    const params = decision.queryParams ? `?${new URLSearchParams(decision.queryParams).toString()}` : '';
    const url = `${decision.target}${params}`;
    return (
      <>
        <UILoader isFull />
        <Navigate to={url} replace />
      </>
    );
  }

  if (decision.type === 'external-redirect') {
    window.location.href = decision.target;
    return <UILoader isFull />;
  }

  return <Outlet />;
};
